<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Protocol Site list"
          text=""
          class="elevation-1"
        >
          <!--v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            v-if="$can('upsert', 'protocol_site')"
            @click="upsertDialog({isNew:true})"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn-->

          <v-data-table
            id="protocol_site_dataTable"
            :headers="headers"
            :items="protocol_sites"
            :pagination.sync="pagination"
            :total-items="totalProtocolSites"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              v-slot:progress
              color="primary"
              indeterminate
            ></v-progress-linear>

            <!--template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-dark text-success text-darken-3"
                v-text="header.text"
              />
            </template-->

            <template slot="headers" slot-scope="props">
              <tr>
                <th 
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>mdi-menu-down</v-icon>
                  <span 
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  />
                </th>
              </tr>
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-text-field
                      clearable
                      md4
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      @input="filterChanged(filters[header.value])"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-autocomplete>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
             
              <td class="text-xs-left">{{ item.protocol.name }}</td>
              <td class="text-xs-left">{{ item.site.name }}</td>
              <td class="text-xs-left">{{ item.site.country_code }}</td>
              <td class="text-xs-left">{{ item.code }}</td>

              <td class="text-xs-right">
                <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                  </v-tooltip>
              </td>                

              <!--  <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="upsertDialog(item)">
                        <v-icon v-if="$can('upsert', 'protocol_site')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'protocol_site')" v-on="on" color="primary">mdi-eye</v-icon>
                    </a>
                  </template>
                  <span>Protocol Site Details</span>
                </v-tooltip>

                &nbsp;&nbsp;&nbsp;&nbsp;

                <v-tooltip top _v-if="$can('delete', 'protocol_site')">
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="confirmDelete(item)">
                      <v-icon v-if="$can('delete', 'protocol_site')" v-on="on" color="primary">mdi-delete-forever</v-icon>
                    </a>
                  </template>
                  <span>Remove Protocol Site</span>
                </v-tooltip>

              </td-->
            </template>
          </v-data-table>
        </material-card>


        <v-dialog v-model="confirm_delete_dialog" persistent max-width="500px">
          <material-card color="red" title="Delete Protocol Site">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout wrap>
                  
                  <v-flex md12>
                      Are you sure you want to delete this Site <b>"{{selectedItem.site.name}}"</b> for <b>"{{selectedItem.protocol.name}}"</b> Protocol? <br><br> ATTENTION!!! This operation is NOT reversible.<br><br>
                  </v-flex>
                
                </v-layout>
              </v-container>
            </v-form>
            <v-flex xs12 text-xs-right>
              <v-btn class="mx-1 font-weight-light" color="danger" @click="remove()">Delete</v-btn>
              <v-btn class="mx-1 font-weight-light" color="primary" @click="closeDelete()">Cancel</v-btn>
            </v-flex>
          </material-card>
        </v-dialog>

      </v-flex>
    </v-layout>

    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="protocol_has_site" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>

  </v-container>
</template>


<script>
import { getList, remove as removeProtocolSite } from "@/api/protocol_site";
import { normalizeFilters } from "@/utils/filters";

export default {
  data() {
    return {
      confirm_delete_dialog: false,
      selectedItem: {site:{}, protocol:{}},
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: 'protocol_id',
        descending: true,
        totalItems: undefined
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      rowsPerPageItems: [5,10,25],
      loading: true,
      totalProtocolSites: 0,
      headers: [
        {
          text: "Protocol",
          align: "left",
          sortable: true,
          value: "protocol.name"
        },
        {
          text: "Site",
          align: "left",
          sortable: true,
          value: "site.name"
        },
        {
          text: "Country",
          align: "left",
          sortable: true,
          value: "site.country_code"
        },
        {
          text: "Site code",
          align: "left",
          sortable: true,
          value: "code"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      // filters: {
      //   name: {
      //     value: undefined,
      //     replace: "VALUE%"
      //   },
      // },
      protocol_sites: []
    };
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
         if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        this.getData();
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
  },
  mounted() {
    this.getData();
    this.$root.$on('updateProtocolSites', () => {
     this.getData();
    });
  },
  computed: {
    filters() {
        return {
          'protocol.name': {
            type:'list',
            list: this.$store.getters.protocols,
            value: undefined,
            placeholder: 'Choose',
            item_text:"name",
            item_value:"name"
          },
          'site.name': {
            type:'text',
            replace: "%VALUE%",
            placeholder: 'Search'
          },
          'site.country_code': {
            type:'text',
            replace: "VALUE",
            placeholder: 'Search'
          },
          code: {
            type:'text',
            replace: "%VALUE%",
            placeholder: 'Search'
          },
          'protocol.sponsor_id': {
            value: this.$store.getters.sponsor_id
          },
        }
     }
  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = `${item.protocol_id}_${item.site_id}`
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;
      getList(normalizeFilters(this.filters), this.pagination).then(data => {
        this.protocol_sites = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalProtocolSites = data.tot;
        this.loading = false;
      });
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.confirm_delete_dialog = true;
    },
    closeDelete() {
      // this.selectedItem = {};
      this.confirm_delete_dialog = false;
    },
    remove() {
      removeProtocolSite(this.selectedItem.protocol_id, this.selectedItem.site_id).then( id => {
        this.closeDelete();
        this.getData();
      });
    },
    filterChanged(filter) {
      this.getData();
      console.log("Filter changed", filter)
    },
    changeSort(column) {
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = false;
      }
      this.pagination = oldPagination;
    },
    upsertDialog(item = {}) {
      this.$store.dispatch(
        "app/openProtocolSiteDialog",
        JSON.parse(JSON.stringify(item))
      );
    }
  }
};
</script>

<style lang="scss">
#protocol_site_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>